module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-6.99769221.png";